// extracted by mini-css-extract-plugin
module.exports = {"root":"_12f8ee","heading":"_1f4825","content":"_bf05fe","divider":"_2a5f72","divider2":"_b6d68b","learnMoreLink":"_2c8220"};